module.exports = __webpack_public_path__ + "img/back_w.794b9c4c.png";